<div [class]="narrow | widthClass">
  <div [class]="columns | columnsClass">
    <app-image *ngFor="let image of images" 
      [image]="image" 
      [imageRatio]="{mobile: 688, tablet: mapCol(), desktop: mapCol()}"></app-image>
  </div>
  <app-caption *ngIf="caption" [caption]="caption"></app-caption>
</div>
